import { gql } from 'graphql-tag';
import type { TypedDocumentNode } from '@apollo/client';
import type { IGetDigitalStudentsPaginatedRosterData, IGetDigitalStudentsPaginatedQueryVars } from '../types';

export const GET_DIGITAL_STUDENTS_PAGINATED_ROSTER: TypedDocumentNode<
  IGetDigitalStudentsPaginatedRosterData,
  IGetDigitalStudentsPaginatedQueryVars
> = gql`
  query getPaginatedStudentRoster($input: PaginatedStudentInput) {
    paginatedStudents(input: $input) {
      lastKey
      students {
        id
        absent
        accommodationsArray {
          code
          description
          supplementalInfo
        }
        asmtSubtypeCd
        candDOB
        candFirstName
        candGender
        candLastName
        candMidInit
        candRegNo
        checkedInCenter
        checkedInRoom
        deniedEntry
        dapExamStatus {
          name
          timestamp
        }
        dapTestStatus {
          name
          payload {
            ... on DAPSectionStartTime {
              sectionName
            }
          }
          timestamp
        }
        displayedRegNo
        estimatedExamEndTime
        examStartTime
        gradeLevel
        groupType
        multiDayInd
        room {
          id
          groupTypes
          title
        }
        specialUseOnly
        studentIds {
          studentId
          studentIdTypeCd
        }
        testPackageCount
        testPackageSeq
        updated
        waitListFlag
        status @client
      }
    }
  }
`;
